import React from 'react';
import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';

const ProgramOutcomesMarquee = ({ items }) => {
  const cards = [...items, ...items];

  return (
    <div className="program-outcomes-marquee" aria-label="Beneficios del programa">
      <FlexContainer className="program-outcomes-marquee__track flex-row">
        {cards.map((item, index) => (
          <FlexContainer
            className="program-outcome-card program-outcome-card--marquee flex-row align-items-center"
            key={`${item.title}-${index}`}
          >
            {item.icon ? (
              <i
                className={`fa-solid ${item.icon} program-outcome-card__icon`}
                aria-hidden="true"
              />
            ) : null}
            <FlexContainer className="program-outcome-card__body flex-column">
              <h3>{item.title}</h3>
              <p>{item.desc}</p>
            </FlexContainer>
          </FlexContainer>
        ))}
      </FlexContainer>
    </div>
  );
};

export default ProgramOutcomesMarquee;
